import { FunctionComponent } from 'react'
import classNames from 'classnames'
import { Icon } from '../../shared/Icon'
import { ModeConfig, ModeId } from './DictationWidget.types'
import { WidgetPopover } from './WidgetPopover.component'
import styles from './DictationWidget.module.scss'

type Props = {
  modes: ModeConfig[]
  activeModeId: ModeId
  direction: 'down' | 'up'
  onSelect: (id: ModeId) => void
  onClose: () => void
}

export const ModeSelector: FunctionComponent<Props> = ({
  modes,
  activeModeId,
  direction,
  onSelect,
  onClose,
}) => (
  <div className={styles.popAnchorMode}>
    <WidgetPopover onClose={onClose} direction={direction}>
      <div className={styles.popTitle}>Mode</div>
      {modes.map((mode) => {
        const isActive = mode.id === activeModeId
        return (
          <button
            key={mode.id}
            className={classNames(styles.popRow, { [styles.popRowActive]: isActive })}
            onClick={() => onSelect(mode.id)}
          >
            <span
              className={classNames(styles.popRowIcon, { [styles.popRowIconActive]: isActive })}
            >
              <Icon icon={mode.iconName} size="pico" color="currentColor" />
            </span>
            <span className={styles.popRowMain}>
              <div className={styles.popRowLabel}>{mode.label}</div>
              <div className={styles.popRowHint}>{mode.hint}</div>
            </span>
            {isActive && <Icon icon="check" size="pico" color="currentColor" />}
          </button>
        )
      })}
    </WidgetPopover>
  </div>
)
